import { render, staticRenderFns } from "./AdminSettingMainLayout.vue?vue&type=template&id=c764fb26&"
import script from "./AdminSettingMainLayout.vue?vue&type=script&lang=js&"
export * from "./AdminSettingMainLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports